import { LoadingOutlined } from '@ant-design/icons';
import toast from 'react-hot-toast';
import styles from './invoiceform.module.scss';
import TemplateSelection from './TemplateSelection';
import Button from '~/components/Button';
import { useDispatch, useSelector } from '~/store';
import { selectIsDownloadLoading, selectIsSubmitLoading } from '~/store/slices/formSlice/selectors';
import { submitFormDataAndDownloadPdf } from '~/store/slices/formSlice/asyncThunks';

interface ISettingsActionProps {
  templateId: string;
}

const SettingsAction = ({ templateId }: ISettingsActionProps) => {
  const isLoading = useSelector(selectIsDownloadLoading);
  const isSubmitLoading = useSelector(selectIsSubmitLoading);
  const dispatch = useDispatch();

  function handleSubmit() {
    const hasError = document.querySelectorAll('.error-field').length > 0;
    if (hasError) {
      toast.error('Please fill all required fields');
      return;
    }
    dispatch(submitFormDataAndDownloadPdf() as any);
  }

  return (
    <div
      className={`${styles.currencyWrapper} ${styles.outInput} ${styles.setInputWrapper} ${styles.setActions}`}
    >
      <TemplateSelection templateId={templateId} />

      <Button
        onClick={handleSubmit}
        data-trigger-id="generate-biodata-trigger-id"
        data-template-id={templateId}
        disabled={templateId === null || isLoading || isSubmitLoading}
      >
        {isLoading || isSubmitLoading ? <LoadingOutlined /> : 'Save'}
      </Button>
    </div>
  );
};

export default SettingsAction;
